import { render } from "./ComOikeusButtons.vue?vue&type=template&id=23f64798&ts=true"
import script from "./ComOikeusButtons.vue?vue&type=script&lang=ts"
export * from "./ComOikeusButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__